


////////////////////////////////
///cart Drawer implementation///
////////////////////////////////

const defaults = {
    cartDrawer: '#modalShoppingCart',
    cartDrawerContent: '.modal-content__inner',
    cartDrawerClose: '.js-ajax-cart-close',
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger',
    removeFromCart: '.js-ajax-remove-from-cart',
    cartWrapper: '.cart-wrapper',
    productsWrapper: '.cart-products',
    cartCounter: 'span.cart__count',
    cartSubtotal: '.drawer-subtotal-price',
    cartQtyInput: '.cartdrawer_input_qty',
    min_btn: '.cartdrawer_min_btn',
    pls_btn: '.cartdrawer_pls_btn',
    cart_btn: '.btn_cart',
    body: 'body'
    // checkoutButton: '.js-ajax-checkout-button'
}
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartWrapper = document.querySelector(defaults.cartWrapper);
const productsWrapper = document.querySelector(defaults.productsWrapper);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
let min_btn = document.querySelectorAll(defaults.min_btn);
let pls_btn = document.querySelectorAll(defaults.pls_btn);
// const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;
const cartCounter = document.querySelector(defaults.cartCounter);
// const cartSubtotal = document.querySelector(defaults.cartSubtotal);
let cartQtyInput = document.querySelectorAll(defaults.cartQtyInput);
const cart_btn = document.querySelector(defaults.cart_btn);
const body = document.querySelector(defaults.body);
function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            // onCartUpdate(cart);
            console.log(cart);
            if (cart.item_count == 0) {
                cartWrapper.innerHTML = '<h3 class="py-5 text-center">Cart is empty</h3>';
                cartCounter.classList.add('d-none');
                // cartSubtotal.innerHTML = Shopify.formatMoney(cart.original_total_price);
                cart_btn.classList.add('disabled');
                // checkoutButton.classList.add('is-hidden');
            } else {
                cartCounter.classList.remove('d-none');
                cart_btn.classList.remove('disabled');
                renderCart(cart);
                // cartSubtotal.innerHTML = Shopify.formatMoney(cart.items_subtotal_price);
                // checkoutButton.classList.remove('is-hidden');
            }
            cartCounter.innerHTML= cart.item_count;
            // cartCounter.innerHTML = cart.item_count;
        },
    });
}

function changeItem(line, quantity, callback) {
    // const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                removeProductFromCart();
                fetchCart();
            }
        },
    });
}

function onCartUpdate(cart) {
    console.log('items in the cart?', cart.item_count);
}

function addToCartOk() {
    // cartModalContent.innerHTML = product.title + ' was added to the cart!';s
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    $(document).find('.cart-link span.badge').removeClass('d-none').show();
    // setTimeout(() => {
        fetchCart();
    //     $.ajax({
    //         type: 'GET',
    //         async: false,
    //         url: '/cart.js',
    //         dataType: 'json',
    //         success: function(cart) {
    //             // onCartUpdate(cart);
    //             console.log(cart);
    //             if (cart.item_count == 0) {
    //                 cartWrapper.innerHTML = '<h3 class="py-5 text-center">Cart is empty</h3>';
    //                 cartCounter.classList.add('d-none');
    //                 // cartSubtotal.innerHTML = Shopify.formatMoney(cart.original_total_price);
    //                 cart_btn.classList.add('disabled');
    //                 // checkoutButton.classList.add('is-hidden');
    //             } else {
    //                 cartCounter.classList.remove('d-none');
    //                 cart_btn.classList.remove('disabled');
    //                 renderCart(cart);
    //                 // cartSubtotal.innerHTML = Shopify.formatMoney(cart.items_subtotal_price);
    //                 // checkoutButton.classList.remove('is-hidden');
    //             }
    //             cartCounter.innerHTML= cart.item_count;
    //             // cartCounter.innerHTML = cart.item_count;
    //         },
    //     });
    //     // alert("added to cart");
    // }, 50);
    openAddModal();
    // openCartOverlay();
     
}

function removeProductFromCart() {
    // // cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    // openCartOverlay();
}

function renderCart(cart) {

    // console.log(cart);

    clearCartDrawer();
    let items = cart.items;
    for (let index = 0; index < items.length; index++) {
        const item = items[index];
        console.log(item.title);
        const productImage = '<div class="cart-product__thumbnail"><a class="d-block h-100" href="'+ item.url +'"><div class="image-ratio image-ratio--square"><img src="' + item.image + '" alt="" class="product-img image-fill"/></div></a></div>';
        const productTitle = '<a href="'+ item.url +'"><h6 class="copy-lg">' + item.title + '</h6></a>';
        // const minus_btn = '<button type="button" class="cartdrawer_min_btn btn-number btn btn-outline-secondary" data-type="minus" data-field="updates[]"><span class="btn-action-minus"><svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.6H0V0H12V1.6Z" fill="currentColor"></path></svg></span></button>';
        // const qty_input = '<div class="col-6"><select id="updates_large_'+ item.key +'" class="select-picker product-qty-'+index+' cartdrawer_input_qty" name="updates[]"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option></select></div>';
        const qty_input = '<div class="col-6"><div class="input-group flex-nowrap"><button type="button" class="btn-number cartdrawer_min_btn btn btn-primary" data-type="minus" data-field="updates[]"><span class="btn-action-minus"><svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.6H0V0H12V1.6Z" fill="currentColor" /></svg></span></button><input type="text" name="updates[]" class="input-number cartdrawer_input_qty input-number--custom" value="1" min="1" max="9999"><button type="button" class="btn-number btn cartdrawer_pls_btn btn-primary" data-type="plus" data-field="updates[]"><span class="btn-action-plus"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"xmlns="http://www.w3.org/2000/svg"><path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="currentColor" /></svg> </span></button></div></div>'
        // const plus_btn = '<button type="button" class="cartdrawer_pls_btn btn-number btn btn-outline-secondary" data-type="plus" data-field="updates[]"><span class="btn-action-plus"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="currentColor"></path></svg></span></button>';
        const productPrice = '<p class="copy-md">' + Shopify.formatMoney(item.line_price) + '</p>';
        const qty_block = '<div class="quantity-select d-none"><div class="row"><div class="col-6"><span class="copy-md quantity-select__placeholder">Qty:</span></div>'+ qty_input +'</div></div>';
        const remove_btn = '<div class="remove-product js-ajax-remove-from-cart"><a href="javascript:void(0)" class="copy-sm">Remove</a></div>';
        const product_meta = '<div class="cart-product__meta">'+productTitle+productPrice+qty_block+remove_btn+'</div>';
        const product_card = '<div class="cart-product" data-handle="'+ item.handle +'" data-line="' + Number(index + 1) + '">'+ productImage + product_meta+ '</div>';
        // const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
        // const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"></div>';

        // const concatProductInfo = '<div class="cart-block border-bottom" data-line="' + Number(index + 1) + '">' + remove_btn + product_card + '</div>';
        // $(document).find('.modal-body.cart-wrapper').append(product_card);
        //productsWrapper.innerHTML = product_card + productsWrapper.innerHTML;
		productsWrapper.innerHTML = productsWrapper.innerHTML + product_card;

        let products_content = $('.cart-products');
        if(products_content.length == 0 ){
            // cartWrapper.innerHTML = 
            let cart_title = '<h6>YOUR CART</h6>';
            let checkout = '</div><div class="btn-wrapper mt-auto"><button type="submit" name="checkout" class="btn btn-primary btn-block btn_cart">Checkout</button></div>';
            let cart_form = cart_title + '<form action="/cart" method="post" class="flex-fill column-fill"><div class="modal-content__inner cart-products mb-4">'+ productsWrapper.innerHTML + checkout +'</form>';
            $('.cart-wrapper').html(cart_form);  
            
        }
        $('.product-qty-'+index+' option').each(function(){
            let _value = $(this).val();
            if(_value == item.quantity ){
                $(this).prop('selected', true).attr('selected', 'selected');
            }
        })

        $('.product-qty-'+index+'').selectpicker({
            style: '',
            styleBase: 'form-control',
            width: 'auto'
        });
    }
    cart.items.forEach(function(item, index) {

        //console.log(item.title);
        //console.log(item.image);
        //console.log(item.line_price);
        //console.log(item.quantity);
        
    });

    // document.querySelectorAll('.js-ajax-remove-from-cart')
    //     .forEach((element) => {
    //         element.addEventListener('click', function() {
    //             const lineID = this.parentNode.getAttribute('data-line');
    //             console.log('aa');
    //         });
    //     });

    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            const line = this.parentNode.parentNode.getAttribute('data-line');
            var quantity = 0;
            console.log(line);
            changeItem(line, quantity);
        });
    }
    cartQtyInput = document.querySelectorAll(defaults.cartQtyInput);    
    // console.log(cartQtyInput)
    for (let i = 0; i<cartQtyInput.length; i++){
        
        // let inventory_qty = getVariantQty(product_handlle);
        cartQtyInput[i].addEventListener('change', function(){
            // let product_handlle = $(this).parents('.cart-product').data('handle');
            // $.getJSON('/products/'+product_handlle+'.js', function (product) {
            //     console.log(product);
            //   });
            // $.ajax({
            //     type: 'GET', 
            //     url: '/products/'+ product_handlle +'.js',
            //     dataType: 'json',
            //     success: function(product){
                
            //     // console.log(product);
            //     let variants = product.variants;
            //     for (let index = 0; index < variants.length; index++) {
            //         const element = variants[index];
            //         console.log(element.inventory_quantity);
                    
            //     }
            //     // fetchCart();
            //     // $('#modalShoppingCart').modal('toggle');
            //     },
            //     error: function(res) {
            //         console.log(res);
            //         // $(".cart__count").text(quantity);
            //     }
            // });
            const line = $(this).parents('.cart-product').data('line');
            var quantity = parseInt($(this).val());
            console.log(line);
            changeItem(line, quantity);
            cartCounter.innerHTML = quantity;
        })
    }
    min_btn = document.querySelectorAll(defaults.min_btn);
    for (let i = 0; i<min_btn.length; i++){
        min_btn[i].addEventListener("click", function(){
            let qty_input = this.nextElementSibling;
            let value = qty_input.value;
            let drawer_count = Number(cartCounter.innerHTML);
            qty_input.value = value-1;
            qty_input.dispatchEvent(new Event('change'));
            let cart_val = value;
            // setTimeout(function(){
                cartCounter.innerHTML = drawer_count  - 1;
            // }, 300);
            
        })
    }
    pls_btn = document.querySelectorAll(defaults.pls_btn);
    for (let i = 0; i<pls_btn.length; i++){
        pls_btn[i].addEventListener("click", function(){
            let qty_input = this.previousElementSibling;
            let value = parseInt(qty_input.value);
            let drawer_count = Number(cartCounter.innerHTML);
            qty_input.value = value+1;
            // alert(value+1);
            qty_input.dispatchEvent(new Event('change'));
            $('#cart-number').text('');
            let cart_val = 1+value;
            // setTimeout(function(){
                cartCounter.innerHTML = drawer_count + 1;
            // }, 300);
        })
    }
}

// function openCartDrawer() {
//     cartDrawer.classList.add('is-open');
// }

// function closeCartDrawer() {
//     cartDrawer.classList.remove('is-open');
// }

function getVariantQty(product_handlle){
    $.ajax({
        type: 'GET', 
        url: '/products/'+ product_handlle +'.js',
        dataType: 'json', 
        data: data,
        success: function(res){
        
          console.log(res);
         
         // fetchCart();
         // $('#modalShoppingCart').modal('toggle');
        },
        error: function(res) {
            console.log(res);
            $(".cart__count").text(quantity);
        }
     });
}

function clearCartDrawer() {
    productsWrapper.innerHTML = '';
    // console.log('cleared');
}

function openAddModal() {
    // cartModal = document.querySelector('#modalShoppingCart');
    // $(defaults.cartDrawerTrigger).trigger('click');
    $('#modalShoppingCart').modal('toggle');
}

function closeAddModal() {
    cartModal = document.querySelector('#modalShoppingCart');
    body.classList.remove('modal-open');
    cartModal.classList.remove('show');
}

// function openCartOverlay() {
//     cartOverlay.classList.add('is-open');
//     htmlSelector.classList.add('is-locked');
// }

// function closeCartOverlay() {
//     cartOverlay.classList.remove('is-open');
//     htmlSelector.classList.remove('is-locked');
// }

// cartDrawerClose.addEventListener('click', function() {
//     closeAddModal();
//     // closeCartOverlay();
// });

// cartDrawerClose.addEventListener('click', function() {
//     closeCartDrawer();
//     closeCartOverlay();
// });
// cart is empty stanje
// cartOverlay.addEventListener('click', function() {
//     closeAddModal();
//     closeCartDrawer();
//     closeCartOverlay();
// });

// cartDrawerTrigger.addEventListener('click', function(event) {
//     event.preventDefault();
//     //fetchCart();
//     openCartDrawer();
//     openCartOverlay();
// });

document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});
$(function(){})
function addItem(form_id) {
    var quantity = parseInt($("span#cart-number").data('count'));
    var data = $('#'+form_id).serialize();
    // console.log(quantity);
    $.ajax({
       type: 'POST', 
       url: '/cart/add.js',
       dataType: 'json', 
       data: data,
       success: function(){
        console.log("success");
        setTimeout(() => {
            addToCartOk(quantity);
        }, 50);
        // console.log(productsWrapper);
        
        // fetchCart();
        // $('#modalShoppingCart').modal('toggle');
       },
       error: function(res) {
           console.log(res);
           $(".cart__count").text(quantity);
       }
    });
 } 




/////////////////////////
//////End Ajax Cart//////
/////////////////////////